export default "__VITE_ASSET__pM2$JkaU__"